import { localizedStrings } from '@core/strings'
import {
  SelectFilterInternalArguments,
  SelectFilterValue,
  useSelectFilter,
} from './fundamentals'
import { FilterHookArgumentsBase } from '@core/providers/filters'
import { useGetInspectionTemplates } from '@core/react-query/features/projects/inspectionTemplates'

type InspectionTemplatesFilterHookArgs<Multiple extends boolean | undefined> =
  FilterHookArgumentsBase<SelectFilterValue<number, Multiple>> & {
    projectId: number
    multiple?: Multiple
    nothingSelectedText?: string
  }

export const useInspectionTemplatesFilter: <
  Multiple extends boolean | undefined,
>(
  arg: InspectionTemplatesFilterHookArgs<Multiple>,
) => SelectFilterInternalArguments<number, Multiple> = ({
  projectId,
  nothingSelectedText = localizedStrings.allInspections,
  ...args
}) => {
  const { data } = useGetInspectionTemplates({
    projectId,
    page: 1,
    size: 1000,
  })

  const inspectionTemplates = data?.content

  return useSelectFilter({
    ...args,
    options: inspectionTemplates?.map((template) => template.templateId) || [],
    valueToLabel: (id) =>
      inspectionTemplates?.find((template) => template.templateId === id)
        ?.templateName,
    nothingSelectedText,
  })
}
